/**
 * @generated SignedSource<<197facd87026469d8e8814938333f78a>>
 * @relayHash f56659a91edb3c53df0efb891f9ae234
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f248788b8871797d3b9023c6108bd7847c909c8ea58b7e9c168164749318b47

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraRankMutationEdge = "BOTTOM" | "TOP" | "%future added value";
export type JiraRankMutationInput = {
  edge: JiraRankMutationEdge;
  issues: ReadonlyArray<string>;
  relativeToIssue: string;
};
export type useOnDrop_issueTableRow_Mutation$variables = {
  rankInput: JiraRankMutationInput;
};
export type useOnDrop_issueTableRow_Mutation$data = {
  readonly jira: {
    readonly rankIssues: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useOnDrop_issueTableRow_Mutation = {
  response: useOnDrop_issueTableRow_Mutation$data;
  variables: useOnDrop_issueTableRow_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rankInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "rankInput",
    "variableName": "rankInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useOnDrop_issueTableRow_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraRankMutationPayload",
            "kind": "LinkedField",
            "name": "rankIssues",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useOnDrop_issueTableRow_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraRankMutationPayload",
            "kind": "LinkedField",
            "name": "rankIssues",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7f248788b8871797d3b9023c6108bd7847c909c8ea58b7e9c168164749318b47",
    "metadata": {},
    "name": "useOnDrop_issueTableRow_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f5872de9c00676cc10d47e5c338fc26b";

export default node;
